import { createAction, props } from '@ngrx/store';

import { CategoryNavMenus } from '../models/category-nav-menus.model';
import { CategoryFilterState } from '../models/category-page.models';
import { filterGroupArrayNames, orderTypes, ProductFilterItem } from '../modules/filters/models/product-filter.models';

import { CategoryState } from './category-page.state';

import { Category } from '@core/domain/models/category.models';
import { SeoInfo } from '@core/domain/models/seo-info.model';
import { ProductsArrayPublicModels } from '@features/productsArray';
import { DisplayFilters } from '@shared/ab-testing/models/AB-testing.models';

export const CategoryActionTypes = {
    INIT_CATEGORY_PAGE: '[category-page] INIT_CATEGORY_PAGE',
    INIT_CATEGORY_PAGE_SUCCESS: '[category-page] INIT_CATEGORY_PAGE_SUCCESS',
    LOAD_CATEGORY_PAGE: '[category-page] LOAD_CATEGORY_PAGE',
    LOAD_LANDING_PAGE: '[category-page] LOAD_LANDING_PAGE',
    LOAD_CATEGORY_PAGE_SUCCESS: '[category-page] LOAD_CATEGORY_PAGE_SUCCESS',
    LOAD_NEW_COLLECTION_PAGE_SUCCESS: '[category-page] LOAD_NEW_COLLECTION_PAGE_SUCCESS',
    LOAD_CATEGORY_PAGE_ERROR: '[category-page] LOAD_CATEGORY_PAGE_ERROR',

    LOAD_CATEGORY_SUCCESS: '[category-page] LOAD_CATEGORY_SUCCESS', // evento de finalización de la peticion http de detalle de categoría
    LOAD_SEO_INFO_SUCCESS: '[category-page] LOAD_SEO_INFO_SUCCESS',
    SET_SEO_CATEGORY_NAME: '[category-page] SET_SEO_CATEGORY_NAME',

    LOAD_PRODUCTS_STUDIO: '[category-page] LOAD_PRODUCTS_STUDIO',
    LOAD_PRODUCTS_STUDIO_SUCCESS: '[category-page] LOAD_PRODUCTS_STUDIO_SUCCESS',

    SET_PRODUCTS_ID: '[category-page] SET_PRODUCTS_ID',

    SET_FILTER_PRODUCT: '[category-page] SET_FILTER_PRODUCT',
    SET_FILTER_ITEM_PRODUCT: '[category-page] SET_FILTER_ITEM_PRODUCT',
    SET_FILTER_IS_APPLIED: '[category-page] SET_FILTER_IS_APPLIED',
    SET_ORDER_PRODUCT: '[category-page] SET_ORDER_PRODUCT',

    SET_MENU_CATEGORIES: '[category-page] SET_MENU_CATEGORIES',
    LOAD_MENU_CATEGORIES: '[category-page] LOAD_MENU_CATEGORIES',
    SET_DISPLAY_FILTER: '[category-page] SET_DISPLAY_FILTER',
    SET_REORDERED_FILTERS: '[category-page] SET_REORDERED_FILTERS',
    SET_CATEGORY_PAGE_STYLES: '[Category-page] SET_CATEGORY_PAGE_STYLES',

    DESTROY_STATE_CATEGORY_PAGE: '[category-page] DESTROY_STATE_CATEGORY_PAGE',
    SET_LAST_STATE_VIEWED: '[category-page] SET_LAST_STATE_VIEWED',

    RESET_CATEGORY_PAGE: '[category-page] RESET_CATEGORY_PAGE',
};

export const DestroyStateCategoryPage = createAction(CategoryActionTypes.DESTROY_STATE_CATEGORY_PAGE);

export const LoadCategorySuccess = createAction(
    CategoryActionTypes.LOAD_CATEGORY_SUCCESS,
    props<{ category: Category }>()
);

export const LoadProductsStudioSuccess = createAction(
    CategoryActionTypes.LOAD_PRODUCTS_STUDIO_SUCCESS,
    props<{ categoryProducts: ProductsArrayPublicModels.PublicCategoryPlatformStudio }>()
);

export const LoadProductsStudio = createAction(
    CategoryActionTypes.LOAD_PRODUCTS_STUDIO,
    props<{ categoryId: string }>()
);

export const LoadSeoInfoSuccess = createAction(
    CategoryActionTypes.LOAD_SEO_INFO_SUCCESS,
    props<{ seoInfo: SeoInfo }>()
);

export const SetSeoCategoryName = createAction(
    CategoryActionTypes.SET_SEO_CATEGORY_NAME,
    props<{ seoCategoryName: string }>()
);

export const InitCategoryPage = createAction(CategoryActionTypes.INIT_CATEGORY_PAGE);

export const InitCategoryPageSuccess = createAction(
    CategoryActionTypes.INIT_CATEGORY_PAGE_SUCCESS,
    props<{ categoryId: string }>()
);

export const LoadCategoryPage = createAction(CategoryActionTypes.LOAD_CATEGORY_PAGE, props<{ categoryId: string }>());

export const LoadLandingPage = createAction(CategoryActionTypes.LOAD_LANDING_PAGE, props<{ landing: string }>());

export const SetLastStateViewed = createAction(CategoryActionTypes.SET_LAST_STATE_VIEWED);

export const LoadCategoryPageSuccess = createAction(
    CategoryActionTypes.LOAD_CATEGORY_PAGE_SUCCESS,
    props<{ categoryProducts: ProductsArrayPublicModels.PublicCategoryPlatformStudio; lastState?: CategoryState }>()
);

export const LoadNewCollectionPageSuccess = createAction(
    CategoryActionTypes.LOAD_NEW_COLLECTION_PAGE_SUCCESS,
    props<{ elementDefaultImageTypes: Map<number, string> }>()
);

export const LoadCategoryPageError = createAction(
    CategoryActionTypes.LOAD_CATEGORY_PAGE_ERROR,
    props<{ audience: string }>()
);

export const SetProductsId = createAction(
    CategoryActionTypes.SET_PRODUCTS_ID,
    props<{ productsId: number[] }>()
);

export const SetFilterProduct = createAction(
    CategoryActionTypes.SET_FILTER_PRODUCT,
    props<{ filters: CategoryFilterState }>()
);

export const SetFilterItemProduct = createAction(
    CategoryActionTypes.SET_FILTER_ITEM_PRODUCT,
    props<{ filterName: string; filterValues: ProductFilterItem[] }>()
);

export const SetFilterIsApplied = createAction(
    CategoryActionTypes.SET_FILTER_IS_APPLIED,
    props<{ isApplied: boolean }>()
);

export const SetOrderProduct = createAction(CategoryActionTypes.SET_ORDER_PRODUCT, props<{ order: orderTypes }>());

export const SetMenuCategories = createAction(CategoryActionTypes.SET_MENU_CATEGORIES);

// TODO ECOMDUTI-13739 TESTAB TEST A/B - Desarrollo Personalización Contenido - Maqueta de filtros
export const SetDisplayFilter = createAction(
    CategoryActionTypes.SET_DISPLAY_FILTER,
    props<{ displayFilter: DisplayFilters }>()
);

export const LoadMenuCategoriesSuccess = createAction(
    CategoryActionTypes.LOAD_MENU_CATEGORIES,
    props<{ navMenuCategories: CategoryNavMenus; filterTypeUsedAsSubcategories: string }>()
);

// TODO ECOMDUTI-13720 TESTAB TEST A/B - Desarrollo personalizacion contenido orden de filtros
export const SetReorderedFilters = createAction(
    CategoryActionTypes.SET_REORDERED_FILTERS,
    props<{ filters: filterGroupArrayNames[] }>()
);

export const SetCategoryPageStyles = createAction(
    CategoryActionTypes.SET_CATEGORY_PAGE_STYLES,
    props<{ catalogStyles: Record<string, string> }>()
);

export const ResetCategoryPage = createAction(
    CategoryActionTypes.RESET_CATEGORY_PAGE
);
